<template>
  <div class="lb-slip">
    <div class="slip-row" v-for="item in getSlip" :key="item.id">
      <div v-if="item.type === 'BALLS'" class="slip-column-balls">
        <div
          v-for="ball in item.value"
          :class="'clickable-ball-ticket ' + ball.color + '-ball'"
          :id="ball.id"
          :key="ball.id"
          @click="selectBall(ball)"
        >
          <div class="ticket-ball" data-number="8">{{ ball.number }}</div>
        </div>
      </div>
      <div
        v-if="item.type === 'BALLS'"
        class="slip-column-remove"
        @click="removeFromSlip(item.id)"
      >
        <div class="clear-red"></div>
      </div>

      <div v-if="item.type === 'ALLBALLS'" class="slip-extras">
        All Of The Balls
      </div>
      <div v-if="item.type === 'ALLBALLS'" class="slip-extras desc">
        <div
          v-for="ball in balls.filter((ball) => ball.number < 9)"
          :class="'clickable-ball-ticket small ' + ball.color + '-ball'"
          :id="'ball' + ball.id + Math.random()"
          :key="ball.id + Math.random()"
          @click="selectBall(ball)"
        ></div>
      </div>
      <div
        v-if="item.type === 'ALLBALLS'"
        class="slip-column-remove"
        @click="removeFromSlip(item.id)"
      >
        <div class="clear-red"></div>
      </div>

      <div v-if="item.type === 'EXTRAS-COLORS'" class="slip-extras">
        {{ item.name }}
      </div>
      <div v-if="item.type === 'EXTRAS-COLORS'" class="slip-extras desc">
        <div
          v-for="(ball, index) in item.value"
          :class="
            ball.selected
              ? 'clickable-ball-ticket small ' + ball.color + '-ball'
              : 'clickable-ball-hide'
          "
          :id="String(String(index) + String(ball.color))"
          :key="String(String(index) + String(ball.color))"
          @click="selectBall(ball)"
        ></div>
      </div>
      <div
        v-if="item.type === 'EXTRAS-COLORS'"
        class="slip-column-remove"
        @click="removeExtrasFromSlip(item.id)"
      >
        <div class="clear-red"></div>
      </div>

      <div v-if="item.type === 'EXTRAS'" class="slip-extras">
        {{ item.name }}
      </div>
      <div v-if="item.type === 'EXTRAS'" class="slip-extras desc">
        {{ item.value }}
      </div>
      <div
        v-if="item.type === 'EXTRAS'"
        class="slip-column-remove"
        @click="removeExtrasFromSlip(item.id)"
      >
        <div class="clear-red"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $eventBus from "../../eventBus";

export default {
  computed: {
    ...mapGetters(["getSlip"]),
  },
  methods: {
    removeFromSlip(item) {
      $eventBus.$emit("removeItemFromSlip", item);
    },
    removeExtrasFromSlip(item) {
      $eventBus.$emit("removeItemFromSlip", item);
      $eventBus.$emit("removeExtrasFromSlip", item);
    }
  },
  data() {
    return {
      balls: [
        {
          color: "red",
          id: 3,
          number: 1,
          selected: false,
        },
        {
          color: "green",
          id: 3,
          number: 2,
          selected: false,
        },
        {
          color: "purple",
          id: 3,
          number: 3,
          selected: false,
        },
        {
          color: "blue",
          id: 3,
          number: 4,
          selected: false,
        },
        {
          color: "brown",
          id: 3,
          number: 5,
          selected: false,
        },
        {
          color: "yellow",
          id: 3,
          number: 6,
          selected: false,
        },
        {
          color: "orange",
          id: 3,
          number: 7,
          selected: false,
        },
        {
          color: "silver",
          id: 3,
          number: 8,
          selected: false,
        },
        {
          color: "yellow",
          id: 3,
          number: 9,
          selected: false,
        },
        {
          color: "green",
          id: 3,
          number: 10,
          selected: false,
        },
      ],
    };
  },
};
</script>
